module.exports = __webpack_public_path__ + "static/media/search_icon_white.0e5b856c.svg";